/* Starbound Letters — core client runtime (Shopify edition)
   nav toggle, scroll reveal, cart count, wishlist store, form helpers.
   Cart and orders now live in Shopify; only the wishlist stays in localStorage. */
(function () {
  "use strict";
  const R = window.SB_ROUTES || { root: "/", cart: "/cart", cartAdd: "/cart/add", cartChange: "/cart/change", cartUpdate: "/cart/update", search: "/search", allProducts: "/collections/all", moneyFormat: "${{amount}}" };

  const store = {
    get(k, d) { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch {} },
  };

  const SB = {
    root: R.root,
    routes: R,
    /* n = cents (Shopify) or a float when `float` is true */
    money(n, float) {
      const cents = float ? Math.round(Number(n) * 100) : Number(n);
      const amount = (cents / 100).toFixed(2);
      const withComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return String(R.moneyFormat || "${{amount}}")
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, withComma.split(".")[0])
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, amount.split(".")[0])
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace(".", ","))
        .replace(/\{\{\s*amount\s*\}\}/, withComma)
        .replace(/<[^>]+>/g, "");
    },
    /* ---- cart (Shopify AJAX API) ---- */
    cart() { return fetch(R.root.replace(/\/$/, "") + "/cart.js", { credentials: "same-origin" }).then((r) => r.json()); },
    addToCart(formData) {
      return fetch(R.cartAdd + ".js", { method: "POST", body: formData, credentials: "same-origin", headers: { Accept: "application/json" } })
        .then(async (r) => { const j = await r.json(); if (!r.ok) throw j; return j; });
    },
    changeLine(key, qty) {
      return fetch(R.cartChange + ".js", { method: "POST", credentials: "same-origin", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then((r) => r.json());
    },
    renderCount(count) {
      const paint = (n) => document.querySelectorAll("[data-cart-count]").forEach((el) => { el.textContent = n || ""; el.dataset.empty = n ? "false" : "true"; });
      if (typeof count === "number") { paint(count); return Promise.resolve(count); }
      return this.cart().then((c) => { paint(c.item_count); return c.item_count; }).catch(() => 0);
    },
    /* ---- wishlist (product handles, kept in this browser) ---- */
    wishlist() { return store.get("sb_wishlist_v2", []); },
    toggleWish(handle) {
      let w = this.wishlist();
      if (w.includes(handle)) w = w.filter((x) => x !== handle); else w.push(handle);
      store.set("sb_wishlist_v2", w);
      return w.includes(handle);
    },
    /* ---- helpers ---- */
    validateForm(form) {
      let ok = true;
      form.querySelectorAll(".field").forEach((f) => {
        const input = f.querySelector("input,textarea,select");
        if (!input) return;
        const bad = input.required && (!input.value.trim() || (input.pattern && !new RegExp("^" + input.pattern + "$").test(input.value.trim())) || (input.type === "email" && !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(input.value.trim())));
        f.classList.toggle("invalid", !!bad);
        if (bad && ok) { input.focus(); ok = false; }
      });
      return ok;
    },
    status(el, msg, kind) {
      if (!el) return;
      el.textContent = msg;
      el.className = "form-status " + (kind || "success");
    },
    esc(s) { return String(s ?? "").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;"); },
  };
  window.SB = SB;

  /* nav toggle */
  const toggle = document.querySelector("[data-nav-toggle]");
  const nav = document.getElementById("main-nav");
  if (toggle && nav) {
    toggle.addEventListener("click", () => {
      const open = nav.classList.toggle("open");
      toggle.setAttribute("aria-expanded", String(open));
      document.body.style.overflow = open ? "hidden" : "";
    });
    nav.addEventListener("click", (e) => { if (e.target.closest("a")) { nav.classList.remove("open"); document.body.style.overflow = ""; } });
    document.addEventListener("keydown", (e) => { if (e.key === "Escape" && nav.classList.contains("open")) { nav.classList.remove("open"); toggle.setAttribute("aria-expanded", "false"); document.body.style.overflow = ""; toggle.focus(); } });
  }

  /* reveal on scroll */
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
    }, { rootMargin: "0px 0px -8% 0px" });
    document.querySelectorAll(".reveal").forEach((el) => io.observe(el));
  } else {
    document.querySelectorAll(".reveal").forEach((el) => el.classList.add("in"));
  }
  /* fallback: never leave content hidden if observation misses */
  setTimeout(() => document.querySelectorAll(".reveal:not(.in)").forEach((el) => el.classList.add("in")), 1500);

  /* newsletter + contact forms post to Shopify natively; only add the
     light client-side check the v17 site had */
  document.querySelectorAll("#sb-newsletter").forEach((form) => {
    form.addEventListener("submit", (e) => {
      const email = form.querySelector("input[type=email]");
      if (!email.value.trim() || !/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email.value.trim())) {
        e.preventDefault();
        SB.status(form.parentElement.querySelector("[data-newsletter-status]"), "Please enter a valid email address.", "error");
      }
    });
  });
  const contact = document.querySelector("[data-contact-form]");
  if (contact) {
    contact.addEventListener("submit", (e) => {
      if (!SB.validateForm(contact)) { e.preventDefault(); SB.status(contact.querySelector("[data-contact-status]"), "Please complete the highlighted fields.", "error"); }
    });
  }

  /* customer address forms: country -> province lists (Shopify country_option_tags) */
  document.querySelectorAll("[data-address-country]").forEach((c) => {
    const p = document.getElementById(c.dataset.provincesTarget);
    if (!p) return;
    const fill = () => {
      let prov = [];
      try { prov = JSON.parse(c.options[c.selectedIndex].getAttribute("data-provinces") || "[]"); } catch {}
      p.innerHTML = "";
      p.parentElement.style.display = prov.length ? "" : "none";
      prov.forEach((pr) => { const o = document.createElement("option"); o.value = pr[0]; o.textContent = pr[1]; if (pr[0] === p.dataset.default) o.selected = true; p.appendChild(o); });
    };
    const d = c.dataset.default || "United States";
    for (let i = 0; i < c.options.length; i++) if (c.options[i].value === d) { c.selectedIndex = i; break; }
    c.addEventListener("change", fill);
    fill();
  });
})();
